<div class="mart-order-details-title">Store and Customer Messages</div>

<div class="chat-box">
    <div *ngFor="let message of parent.order.Messages">
        <div *ngIf="message.MessageTypeId===1" style="text-align:right">Customer</div>
        <div *ngIf="message.MessageTypeId===1" class="message secondary">{{message.Message}}<div class="timestamp-left">{{message.CreatedAt}}</div></div>

        <div *ngIf="message.MessageTypeId===2">Store</div>
        <div *ngIf="message.MessageTypeId===2" class="message primary">{{message.Message}}<div class="timestamp-right">{{message.CreatedAt}}</div></div>
    </div>
</div>
